


















import { Component, Vue } from 'vue-property-decorator';
import AppSiteNav from '@/components/AppSiteNav.vue';
import AppLoading from '@/components/AppLoading.vue';
import { eventBus, eventBusEvents } from '@/helpers/eventBusHelper';
import { Action } from 'vuex-class';
import AppCookie from '@/components/AppCookie.vue';

@Component({
    name: 'App',
    components: {
        AppSiteNav,
        AppLoading,
        AppCookie,
    },
})
export default class App extends Vue {

    protected get isUserSwitched() {
        return !!this.$store.getters['user/switchedUserEmail'];
    }
    protected isLoading = false;
    @Action('user/getUserData') private getUserData!: (token: string) => void;

    public created() {
        const unwatch = this.$watch(
            () => this.$route,
            (route, prevRoute) => {
                if (this.$route.query._switch_user) {
                    this.$store.dispatch('user/setSwitchedUserEmail', this.$route.query._switch_user);
                    this.getUserData(this.$store.getters['user/token']);
                }
                unwatch();
            },
        );
    }

    public onExitSwitchMode() {
        this.$store.dispatch('user/setSwitchedUserEmail', null);
        this.$router.push(this.$route.path);
        this.$router.go(0);
    }

    protected mounted() {
        eventBus.$on(eventBusEvents.activateGlobalLoading, () => {
            this.isLoading = true;
        });
        eventBus.$on(eventBusEvents.deactivateGlobalLoading, () => {
            this.isLoading = false;
        });
    }
}
